import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";

// initial state
export const initialState = {
  loadingID: false,
  IDVerificationFileDetails: null,
  isConsentStatementSubmitted:false,
};

// our slice
const idVerificationPageSlice = createSlice({
  name: "idVerificationPage",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loadingID = true;
    },
    setError: (state, { payload }) => {
      state.loadingID = false;
      state.error = payload;
    },
    setisConsentStatementSubmitted :(state, { payload }) => {
      state.isConsentStatementSubmitted = payload;
    },
    setIDVerificationFileDetails: (state, { payload }) => {
      state.loadingID = false;
      state.IDVerificationFileDetails = {
        FileID: payload.fileID,
        FileNumber: payload.fileNumber,
        Status: payload.status,
      };
    },
  },
});
// export the actions
export const { setLoading, setError, setIDVerificationFileDetails,setisConsentStatementSubmitted } =
  idVerificationPageSlice.actions;

export const idVerificationPageSelector = (state) => state.idVerificationPage;

// export the default reducer
export default idVerificationPageSlice.reducer;

export const SaveIDVerificationPageDetails =
  (request, userid, navigate) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = { UserID: userid, RequestObject: request };

      const results = await http
        .post("/Order/SaveIDVerificationDetails", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setIDVerificationFileDetails(results.data.responseObject));
        window.location.replace(`/ordersummary/${results?.data?.responseObject?.fileID + 100000}`);
      } else {
        dispatch(setError(results.data.error));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
